import { productTypes } from '~/hooks/useCtbProductInfo';

export const CardActionType = {
  HOSTING_UPGRADE: productTypes?.HOSTING_UPGRADE,
  MONARX_FAMILY: productTypes?.MONARX_FAMILY,
} as const;

export const SEVERITY_COLORS: Record<
  string,
  { accentColor: string; backgroundColor: string; borderColor?: string }
> = {
  error: {
    accentColor: 'error.dark',
    backgroundColor: 'error.50',
    borderColor: 'error.light',
  },
  warning: {
    accentColor: 'warning.dark',
    backgroundColor: 'warning.50',
    borderColor: 'warning.light',
  },
  info: {
    accentColor: 'info.main',
    backgroundColor: 'info.50',
    borderColor: 'info.light',
  },
  custom: { accentColor: '', backgroundColor: '' },
};
